import { message } from 'antd';
import { requestProjectFeedback, getProjectFeedback } from 'HttpRequests/projectFeedback';

export default () => async (dispatch, getState) => {
  const state = getState();
  const project = state.screens.ProjectView.project;

  if (!project) return;

  try {
    dispatch({ type: 'SET_FEEDBACK_LOADING', payload: true });

    await requestProjectFeedback({ 
      id: project.id,
      data: {} // Uses project contact email
    });

    message.success('Feedback request sent successfully!');

    // Reload feedback list
    const response = await getProjectFeedback({ id: project.id });
    dispatch({ type: 'SET_FEEDBACK', payload: response.data.feedback });

  } catch (error) {
    console.error('Error requesting feedback:', error);
    const errorMessage = error.response && error.response.data && error.response.data.error 
      ? error.response.data.error 
      : 'Failed to send feedback request';
    message.error(errorMessage);
  } finally {
    dispatch({ type: 'SET_FEEDBACK_LOADING', payload: false });
  }
};
